// This util exports places for labeling several special entities.

export function palestineLabel (lang) {
  const name = {
    'en': 'State of Palestine',
    'fr': 'État de Palestine',
    'es': 'Estado de Palestina',
    'ar': 'دولة فلسطين'
  };

  return name[lang];
}

